import React, {useState} from 'react';
import download from "../../assets/img/download.png";
import moment from 'moment-timezone';
import 'moment/locale/hy-am.js';
import {useSelector} from "react-redux";
import DeleteItem from "./DeleteItem.js";

function FileItem({name, last_name, company,getCompanyFileData, date, id, file_url, url}) {
    const account = useSelector((state) => state.task.accountant);
    const [deletes, setDelete] = useState('')
    const raiseInvoiceClicked = (url) => {
        localStorage.setItem("pageData", "Data Retrieved from axios request");
        window.open(url, "_blank");
    };
    const handleDelete = () => {
        setDelete(id.split('/')[id.split('/').length-2])

    }

    const findEmployee = () => {
        if (!account || !Array.isArray(account)) return "";
        const match = account.find(item => item.url === url);
        return match ? `${match.user.first_name} ${match.user.last_name}` : "";
    };

    return (
        <div className='file-item'>
            <span className='file-item-data-name'>{name} {last_name}</span>
            <img
                alt="img"
                src={download}
                onClick={() => raiseInvoiceClicked(file_url)}
            />
            <span className='file-item-data'>{moment(date).tz('Asia/Yerevan').format('LLL')}</span>
            <span className='file-item-data'>{company}</span>
            <span className='file-item-data'>{findEmployee()}</span>
            <div className="tool-tip-cont">
                <div className="tool-tip">Ջնջել</div>
                <i className="fas fa-times" onClick={handleDelete}/>
            </div>
            {deletes?<DeleteItem getCompanyFileData={getCompanyFileData} open={deletes} setOpen={setDelete} />:null}
        </div>
    );
}

export default FileItem;
